export * from "@/ui/components/sections/hero/AnimatedHeaderSplash/AnimatedHeaderSplash";
export * from "@/ui/components/sections/hero/AnimatedHeaderSplash/AnimatedHeaderSplash.config";
